export default "__VITE_ASSET__BBL0JuGh__"